exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-PaperTrading-___cards__wrapper___3ec8e{display:grid;width:100%;grid-template-columns:repeat(4, 1fr);grid-column-gap:20px;-webkit-column-gap:20px;-moz-column-gap:20px;column-gap:20px;margin-bottom:20px}.src-components-PaperTrading-___cards__wrapper___3ec8e::before{grid-column:span 5}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-PaperTrading-___cards__wrapper___3ec8e"
};